
import { db } from '@/lib/firebase';
import { collection, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';

const SEED_DATA = [
    {
        title: '비트코인(BTC) 기관형 상품',
        asset: 'BTC',
        description: '기관 물량 확보를 통한 안정적 수익률 보장 상품. 대형 채굴업체와의 직접 계약을 통해 시장가 대비 할인된 가격으로 비트코인을 매입합니다.',
        roi: '12.4%',
        period: '30일',
        progress: 85,
        status: 'Active',
        minInvestment: 5000000,
        targetAmount: 5000000000,
        currentAmount: 4250000000,
        investorCount: 342,
        riskLevel: '보통',
        features: ['기관급 물량 확보', '자동 정산 시스템', '담보 기반 보호', '일일 수익 배분']
    },
    {
        title: '이더리움(ETH) 전략적 제휴형',
        asset: 'ETH',
        description: '레이어2 프로젝트 연계 전략적 블록딜 상품. DeFi 프로토콜과의 제휴를 통해 이더리움 스테이킹 수익과 블록딜 수익을 동시에 확보합니다.',
        roi: '8.5%',
        period: '45일',
        progress: 42,
        status: 'Active',
        minInvestment: 3000000,
        targetAmount: 3000000000,
        currentAmount: 1260000000,
        investorCount: 186,
        riskLevel: '낮음',
        features: ['레이어2 연계', '이중 수익 구조', 'DeFi 프로토콜 보증', '주간 수익 정산']
    },
    {
        title: '리플(XRP) 유동성 풀 상품',
        asset: 'XRP',
        description: '글로벌 결제 네트워크 기반의 유동성 풀 제공 상품. 리플 네트워크의 대규모 거래 유동성을 활용하여 안정적인 수익을 창출합니다.',
        roi: '6.2%',
        period: '60일',
        progress: 28,
        status: 'Active',
        minInvestment: 1000000,
        targetAmount: 2000000000,
        currentAmount: 560000000,
        investorCount: 94,
        riskLevel: '낮음',
        features: ['글로벌 결제 활용', '유동성 보상 구조', '일일 자동 정산', '원금 보장형']
    }
];

export const seedBlockDeals = async (): Promise<boolean> => {
    try {
        const snapshot = await getDocs(collection(db, 'block_deals'));
        if (!snapshot.empty) {
            console.log('Block deals already seeded, skipping...');
            return false;
        }

        for (const deal of SEED_DATA) {
            await addDoc(collection(db, 'block_deals'), {
                ...deal,
                createdAt: serverTimestamp()
            });
        }
        console.log('Successfully seeded 3 block deals!');
        return true;
    } catch (error) {
        console.error('Seeding error:', error);
        return false;
    }
};
